import { checkEsignError, parseErrorStatus } from '../../legacy/constants';
import ApiServiceError from './ApiServiceError';

export const DATASOURCES = {
  ME: 'me',
};

export const getDataSource = (state, name) => {
  const { dataSources } = state.app;

  let dataSource = {
    isFetching: false,
  };

  if (dataSources[name]) {
    dataSource = dataSources[name];
  }

  return dataSource;
};

export function parseResponse(payload) {
  const { errors, error } = payload;
  if (error) {
    const errorStatus = parseErrorStatus(error);
    if (
      errorStatus &&
      checkEsignError(errorStatus[0] && errorStatus[0].errorCode)
    ) {
      throw new Error(JSON.stringify(errorStatus[0]));
    }
  }
  if (errors) {
    throw new ApiServiceError(errors[0].status, errors[0]);
  }
  return payload;
}



// WEBPACK FOOTER //
// ./src/state/services/utils.js